export var compare = function (a, b) {
    if (a.A !== b.A) {
        return a.A - b.A;
    }
    else if (a.B !== b.B) {
        return a.B - b.B;
    }
    else {
        return a.C - b.C;
    }
};
export var compareDesc = function (a, b) {
    return compare(b, a);
};
//# sourceMappingURL=sort.js.map